/* eslint-disable no-undef */
import schema from '@/components/abertura/schema';
import { api } from '@/services';

export default {
  /**
   * @todo: vou melhorar em breve
   */
  async salvarAlteracoes({ dispatch }, payload) {
    try {
      const solicitacaoProcesso = await schema.validate(payload, {
        abortEarly: false,
      });

      const {
        _id,
        itens,
        arquivos,
        ...processo
      } = solicitacaoProcesso;

      if (!processo.etd) {
        processo.etd = '';
      }

      if (!processo.eta) {
        processo.eta = '';
      }

      const formData = new FormData();

      Object.entries(processo).forEach(([key, value]) => {
        formData.append(key, value);
      });

      if (Array.isArray(itens) && itens.length) {
        Object.entries(itens).forEach(([, value], i) => {
          Object.entries(value).forEach(([key, item]) => {
            if (key === 'id') {
              return;
            }

            formData.append(`itens[${i}].${key}`, item);
          });
        });
      }

      if (Array.isArray(arquivos) && arquivos.length) {
        Object.entries(arquivos).forEach(([, value], i) => {
          const { arquivo, ...metadata } = value;
          formData.append(`arquivo[${i}]`, arquivo);
          Object.entries(metadata).forEach(([key, item]) => {
            formData.append(`arquivos[${i}].${key}`, item);
          });
        });
      }

      formData.append('idSolicitacao', solicitacaoProcesso._id);

      const response = await api.post('/processo/solicitar/alterar', formData, {
        headers: {
          'Content-Type': 'multiform/form-data',
        },
      });

      dispatch('solicitacaoProcesso/limparSolicitacaoProcesso', _, { root: true });
      dispatch('solicitacaoProcesso/fecharModal', _, { root: true });

      return response.data;
    } catch (e) {
      return e.inner;
    }
  },
  async fetchAlteracoes({ commit }, payload) {
    const response = await api.get(`/processo/solicitar/alteracoes/${payload._id}`);

    commit('SET_ALTERACOES', response.data);

    return response.data;
  },
  async marcarAlterado({ dispatch }, payload) {
    const { _id } = payload;

    await api.put(`/processo/solicitar/marcar-alterado/${_id}`, payload, {
      'Content-Type': 'application/json',
    });

    dispatch('solicitacaoProcesso/limparSolicitacaoProcesso', _, { root: true });
    dispatch('solicitacaoProcesso/fetchSolicitacoesProcesso', { page: 1, perPage: 20 }, { root: true });
    dispatch('solicitacaoProcesso/fecharModal', _, { root: true });
  },
  async aplicarAlteracao({ dispatch }, payload) {
    const { idSolicitacao } = payload;

    delete payload._id;

    await api.put(`/processo/solicitar/aplicar-alteracao/${idSolicitacao}`, payload, {
      'Content-Type': 'application/json',
    });

    dispatch('solicitacaoProcesso/limparSolicitacaoProcesso', _, { root: true });
    dispatch('solicitacaoProcesso/fecharModal', _, { root: true });
  },
};
